import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmExperienceCustomerAccessRoute: InvariantJiraRoute = {
	name: 'csm-experience-customer-access',
	path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/customer-access',
	exact: true,
};
